import * as React from 'react';
import letterMeta from '@/service/letter-meta';

interface DieProps {
	isDataCorrect: boolean;
	paymentInfo: EnteredPaymentInfo | null;
}

const Die: React.FunctionComponent<DieProps> = ({ isDataCorrect, paymentInfo }) => {
	React.useEffect(() => {
		if (isDataCorrect) {
			letterMeta(paymentInfo);
		}
	});

	return null;
};

export default Die;
